import * as qiniu from 'qiniu-js'
import { initializeApollo } from '~/graphqls/apollo/client'
import { QINIU_TOKEN } from '~/graphqls/gqls'
import { OssBucket } from '~/graphqls/types'

const gqlClient = initializeApollo()

export const getQiNiuToken = (
  fileName: string | undefined,
  bucket: OssBucket,
  dirName?: string
) => {
  return gqlClient.query({
    query: QINIU_TOKEN,
    fetchPolicy: 'network-only', // 禁止缓存oss token
    variables: {
      fileName,
      bucket,
      dirName,
    },
  })
}

/**
 * @doc
 * https://developer.qiniu.com/kodo/1283/javascript
 * @param file
 * @param fileName 文件名为 undefined，自动用hash作为文件名
 * @param dirname 文件存储路径
 * @param bucket 默认值TRADE_PROTECT（开启原图保护），作用于作品
 * @returns
 */
/**
 * @doc
 * https://developer.qiniu.com/kodo/1283/javascript
 * @param file
 * @param fileName 文件名为 undefined，自动用hash作为文件名
 * @param bucket 默认值TRADE_PROTECT（开启原图保护），作用于作品
 * @returns
 */
export const uploadQiNiu = async (
  file: File,
  fileName: string | undefined,
  bucket: OssBucket = OssBucket.TRADE_PROTECT,
  dirname?: string
) => {
  const res = await getQiNiuToken(fileName, bucket, dirname)
  const token = res.data.upToken.token
  const observable = qiniu.upload(file, fileName, token)

  const p = new Promise((resolve, reject) => {
    observable.subscribe({
      error(err) {
        reject(err)
      },
      complete(res) {
        resolve(res)
      },
    })
  })

  const uploadRes: any = await p
  return uploadRes.baseUrl + '/' + uploadRes.key
}
